import { Flex } from "../../primitives/Flex";
import { styled } from "@pigment-css/react";
import { PercentageChip } from "../../primitives/PercentageChip";

interface MetricCardProps {
  label: string;
  value: string;
  change: number | null;
  changeTooltip?: string;
}

const CardContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.managementView.spacing[16],
}));

const MetricLabel = styled("span")(({ theme }) => ({
  fontFamily: theme.managementView.font.family,
  fontSize: theme.managementView.font.size[14],
  fontWeight: theme.managementView.font.weight[500],
  color: theme.managementView.colors.neutral[56],
}));

const MetricValue = styled("span")(({ theme }) => ({
  fontFamily: theme.managementView.font.familySecondary,
  fontSize: theme.managementView.font.size[17],
  fontWeight: theme.managementView.font.weight[500],
  color: theme.managementView.colors.neutral[90],
}));

export const MetricCard = ({ label, value, change, changeTooltip }: MetricCardProps) => {
  return (
    <CardContainer>
      <Flex direction="column" gap={8}>
        <MetricLabel>{label}</MetricLabel>
        <MetricValue>{value}</MetricValue>
      </Flex>
      {change !== null && (
        <div>
          <PercentageChip value={change} tooltip={changeTooltip} />
        </div>
      )}
    </CardContainer>
  );
};
